import React, { useContext, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { Button, Dialog, InputText } from "iuvity-ui-components";
import { AppContext } from "../../context";
import { ErrorMessage } from "@hookform/error-message";


interface DeleteTenantProps {
  visible: boolean;
  closeHandler: Function;
  confirmHandler: Function;
}


export const DeleteTenant: React.FC<DeleteTenantProps> = ({
  visible,
  closeHandler,
  confirmHandler
}) => {
  const {
    t,
    appState: { selectedTenant },

  } = useContext(AppContext);

  const TenantDeleteSchema = (t: Function) => {
    return {
      name: {
        required: {
          value: true,
          message: t("GlobalConfigurations.requiredErrorMessage"),
        },
        pattern: {
          value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
          message: t("GlobalConfigurations.generalErrorMessage"),
        },
        minLength: {
          value: 1,
          message: t("GlobalConfigurations.generalErrorMessage"),
        },
        maxLength: {
          value: 50,
          message: t("GlobalConfigurations.generalErrorMessage"),
        },
        keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
        validate: {
          equal: (v: any) => v == selectedTenant?.name || t('Tenants.deleteNameValidationLabel')
        }
      },
      guid: {
        required: {
          value: true,
          message: t("GlobalConfigurations.requiredErrorMessage"),
        },
        keyfilter: /^[a-zA-Z0-9-]*$/,
        maxLength: {
          value: 14,
          message: t("GlobalConfigurations.generalErrorMessage"),
        },
        validate: {
          equal: (v: any) => v == selectedTenant?.guid || t('Tenants.deleteGuidValidationLabel')
        }
      }
    };
  };

  const {
    control,
    formState: { errors, isValid },
    watch,
    resetField
  } = useForm({
    mode: "onChange",
    delayError: 1200,
    reValidateMode: "onChange",
    defaultValues:
    {
      name: "",
      guid: ""
    }
  });
  useEffect(() => {
    resetField('name');
    resetField('guid');

  }, [visible])



  const renderFooter = () => {
    return (
      <div className="flex align-items-center justify-content-flex-end">
        <Button
          label={t("Tenants.rejectBtnLabel")}
          onClick={() => closeHandler()}
          className="mr-4"
          variant="p-button-text"
        />
        <Button
          label={t("Tenants.acceptBtnLabel")}
          className="mr-4"
          variant="p-button"
          disabled={(!(isValid && watch('name') == selectedTenant?.name && watch('guid') == selectedTenant?.guid))}
          onClick={() => confirmHandler()}
        />
      </div>
    );
  };

  return (
    <Dialog
      id="dialogScroll1"
      className="dialog-form"
      header={<>{t("Tenants.deleteModalTitle")}</>}
      visible={visible}
      onHide={() => closeHandler()}
      style={{ width: "25.4375rem", height: 'auto' }}
      footer={renderFooter}
      draggable={false}
    >
      <p className="pb-4 description-delete-app">
        {t("Tenants.deleteModalContent1")}
      </p>
      <div
        className=""
      >
        <Controller
          name={'name' as any}
          control={control}
          rules={(TenantDeleteSchema(t) as any)['name']}
          render={({ field }) => {
            return <div className='app-fields' style={{ width: '100%', marginLeft: '1.5rem' }}>
              <InputText
                id={`input-label-name}`}
                label={t(`Tenants.deleteNameLabel`)}
                placeholder={t(`Tenants.deleteNamePlaceholder`)}
                className={errors.name?.message ? "p-invalid p-invalid-delete" : "mb-4 mt-2"}
                type="text"
                autoComplete="off"
                keyfilter={TenantDeleteSchema(t)?.name?.keyfilter}
                maxLength={TenantDeleteSchema(t)?.name?.maxLength?.value}
                {...field}
                value={field.value}
              />
            </div>

          }}
        />
        {['name'].includes('name') &&
          <ErrorMessage
            errors={errors}
            name="name"
            //@ts-ignore
            render={({ message }) => (
              <small
                className="p-error block"
                style={{ marginTop: "0.5rem", marginBottom: "1rem", marginLeft: "1.5rem" }}
              >
                {message}
              </small>
            )}
          />}

        <Controller
          name={'guid' as any}
          control={control}
          rules={(TenantDeleteSchema(t) as any)['guid']}
          render={({ field }) => {
            return <div className='app-fields' style={{ width: '100%', marginLeft: '1.5rem' }}>
              <InputText
                id={`input-label-guid`}
                label={t(`Tenants.deleteGuidLabel`)}
                placeholder={t(`Tenants.deleteGuidPlaceholder`)}
                className={errors.guid?.message ? "p-invalid p-invalid-delete" : "mb-2 mt-2"}
                type="text"
                autoComplete="off"
                keyfilter={TenantDeleteSchema(t)?.guid?.keyfilter}
                maxLength={TenantDeleteSchema(t)?.guid?.maxLength?.value}
                {...field}
                value={field.value}
              />
            </div>

          }}
        />
        {['guid'].includes('guid') &&
          <ErrorMessage
            errors={errors}
            name="guid"
            //@ts-ignore
            render={({ message }) => (
              <small
                className="p-error block"
                style={{ marginTop: "0.5rem", marginBottom: "1rem", marginLeft: "1.5rem" }}
              >
                {message}
              </small>
            )}
          />}
      </div>
      <p className="description-delete-app">
        <div dangerouslySetInnerHTML={{ __html: t("Tenants.deleteModalContent2") }} />
      </p>
    </Dialog>
  );
};
